import {
  getStepFields,
  STEP_ORDER,
  type FieldDefinition,
  type StepKey,
} from '@config/formSteps';
import {
  CREA_ENTREPRISE_BITRIX_IDS,
  DELAI_DEBUT_BITRIX_IDS,
  ESTHETIQUE_BITRIX_IDS,
  FORMATEUR_BITRIX_IDS,
  PETITE_ENFANCE_BITRIX_IDS,
  TP_DEV_BITRIX_IDS,
  UNCOVERED_DOMAIN_ID,
} from '@config/lists';
import { type Catalog } from '@core/catalog';

const BITRIX_GATED_STEPS: readonly {
  steps: readonly StepKey[];
  ids: Set<number>;
}[] = [
  { steps: ['delaiDebut'], ids: DELAI_DEBUT_BITRIX_IDS },
  {
    steps: ['domaineExpertise', 'transmettreCompetences'],
    ids: FORMATEUR_BITRIX_IDS,
  },
  {
    steps: ['experienceEsthetique', 'interetsEsthetique', 'stageEsthetique'],
    ids: ESTHETIQUE_BITRIX_IDS,
  },
  {
    steps: ['ideeProjet', 'typeStructure', 'secteurActivite'],
    ids: CREA_ENTREPRISE_BITRIX_IDS,
  },
  {
    steps: ['formationPetiteEnfance', 'stagePetiteEnfance'],
    ids: PETITE_ENFANCE_BITRIX_IDS,
  },
  {
    steps: ['equipementInfo', 'niveauAnglais'],
    ids: TP_DEV_BITRIX_IDS,
  },
];

const fieldNames = (field: FieldDefinition): string[] =>
  field.kind === 'flex' ? field.components.map((c) => c.name) : [field.name];

export const computeVisibleSteps = ({
  answers,
  catalog,
}: {
  answers: Record<string, unknown>;
  catalog: Catalog;
}): StepKey[] => {
  const { themes, formQueryParams } = catalog;
  const startIndex = formQueryParams.etape ?? 1;

  const prefilledFields = Object.entries(formQueryParams)
    .filter(([key, value]) => key !== 'etape' && value !== undefined)
    .map(([key]) => key);
  const prefilledStepKeys = STEP_ORDER.filter((key) =>
    getStepFields(key, { answers, catalog }).some((field) =>
      fieldNames(field).some((name) => prefilledFields.includes(name)),
    ),
  );

  const domainFormations =
    themes.find((theme) => theme.id === answers.domainId)?.formations ?? [];
  const skipTraining =
    answers.domainId === UNCOVERED_DOMAIN_ID || domainFormations.length === 1;
  const formationId = Number(answers.idFormationBitrix);

  return STEP_ORDER.slice(startIndex - 1)
    .filter((key) => !prefilledStepKeys.includes(key))
    .filter((key) => !(key === 'training' && skipTraining))
    .filter((key) =>
      BITRIX_GATED_STEPS.every((group) =>
        group.steps.includes(key) ? group.ids.has(formationId) : true,
      ),
    );
};
